// 个人信息模块
export default {
    Personal: {
        SetPassword: 'Set password',
        PleaseEnterPassword: 'Please enter password',
        PleaseEnterPasswordAgain: 'Please enter password again',
        ChangePassword: 'Change password',
        PleaseEnterOldPassword: 'Please enter your old password',
        PleaseEnterOldPassword2: 'Please enter your old password',
        PleaseEterNewPassword: 'Please enter a new password',
        PleaseEterNewPassword2: 'Please enter a new password',
        PleaseEnterNewPasswordAgain: 'Please enter the new password again',
        ModifyAvatar: 'Modify Avatar',
        LocalUpload: 'Local Upload',
        LocalUploadTip: 'Only supports JPG, GIF, PNG, JPEG, BMP formats, files smaller than 5M',
        EffectPreview: 'Effect Preview',
        Pixels: '100 * 100 pixels',
        UserInformation: 'User information',
        HeadPortrait: 'Avatar:',
        ReplaceAvatar: 'Replace avatar',
        UserName: 'User name:',
        EnterUserName: 'Enter one user name',
        UserNameCanOnlyModifiedOnce: 'User name can only be modified once',
        ModifyUserName: 'Modify User Name',
        NewUsername: 'New username',
        CellPhoneNumber: 'Phone number:',
        PleaseEnterPhoneNumber: 'Please enter your phone number',
        PleaseBindPhoneNumber: 'According to the regulations of the Cyberspace Office, information must be bound to a mobile number. Please bind your phone number in a timely manner.',
        UnbindPhoneNumber: 'Unbind phone number',
        BindPhoneNumber: 'Bind phone number',
        PleaseEnterYourPhoneNumber: 'Please enter your phone number',
        PleaseEnterVerificationCode: 'Please enter the verification code',
        SendVerificationCode: 'Send verification code',
        Resend: 'Resend',
        Password: 'Password:',
        Mailbox: 'Email:',
        SetUpEmail: 'Set up email',
        BindEmail: 'Bind email',
        ModifyEmail: 'Modify email',
        VerifyEmailAddress: 'Verify email address',
        EmailAddress: 'Mailing address',
        SendVerificationEmail: 'Send verification email',
        SendEmail: 'Send email',
        SentTo: 'The verification email has been sent to your email',
        PleaseCheckEmail: ', please check it',
        NoEmailReceived: "Didn't receive the email? Please check for spam or click",
        FullName: 'Name:',
        PleaseEnterYourName: 'Please enter your name',
        Address: 'Address:',
        PleaseSelectProvince: 'Please select a province',
        PleaseSelectCity: 'Please select a city',
        PleaseSelectCounty: 'Please select a county',
        ModifyAddress: 'Modify Address',
        PleaseEnterCorrectPhoneNumber: 'Please enter the correct phone number',
        PhoneNumberCannotEmpty: 'Mobile phone number cannot be empty!',
        UserNameCannotEmpty: 'User name cannot be empty!',
        PleaseFillEmailAddress: 'Please fill in the email address!',
        PleaseFillCorrectEmailAddress: 'Please fill in the correct email address!',
        FileCannotExceed5MB: 'The size of the uploaded file cannot exceed 5MB. Please reselect the image!',
        OldPasswordCannotEmpty: 'Old password cannot be empty',
        NewPasswordCannotEmpty: 'The new password cannot be empty',
        SecondaryPasswordCannotEmpty: 'Secondary password cannot be empty',
        PasswordsEnteredDifferent: 'The two passwords you entered are not the same!',
        SuccessfullyModified: 'Successfully modified',
        SuccessfullySet: 'Successfully set',
        PleaseSelectCityOrCounty: 'Please select a city or county'
    },
  };